import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import DebitForm from './debit-form/debitForm';
import { KEY } from 'web/components/utils/stripeKey';
import styles from './debit.module.scss';
const AddCard = ({ type, individual,getProfileResponse, callBackFetchApi, callBackModal, props, callBack, paymentType, pageLanguageContents }) => {
  const stripePromise = loadStripe(KEY);
  return (
    <div className='col-12 p-0'>
      <div className={styles.body}>
        <Elements stripe={stripePromise}>
          <DebitForm  getProfileResponse={getProfileResponse} type={type} individual={individual} props={props} callBackModal={callBackModal} callBackFetchApi={callBackFetchApi} 
          callBack={() => {
            callBack()
          }} paymentType={paymentType} pageLanguageContents={pageLanguageContents} />
        </Elements>
      </div>
    </div>
  );
};
export default AddCard;
